module.exports = __webpack_public_path__ + "static/media/attitudesports.90adaf1d.jpg";